import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5997cc3b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "cCode" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
    key: 0,
    class: "text-grey"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, " sn: ", -1));
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = { class: "text-militaryGreen" };
const _hoisted_10 = ["innerHTML"];
import { getConditionColor } from './sp';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ShortPartsList',
    props: {
        sparts: {},
        noPartsText: {}
    },
    emits: ["toggleSparePart"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_alert = _resolveComponent("v-alert");
            return (_ctx.sparts.length)
                ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sparts, (spart) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: spart.id
                            }, {
                                prepend: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                        _createVNode(_component_v_chip, {
                                            color: _unref(getConditionColor)(spart.condition_code),
                                            variant: "tonal",
                                            size: "small"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("b", null, _toDisplayString(spart.condition_code), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["color"])
                                    ])
                                ]),
                                title: _withCtx(() => [
                                    _createElementVNode("span", {
                                        innerHTML: spart.metadata.part_number_html || spart.part_number
                                    }, null, 8, _hoisted_2),
                                    (spart.metadata.part_number_alt_1_html || spart.part_number_alt_1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                            _createTextVNode(" ("),
                                            _createElementVNode("span", {
                                                innerHTML: spart.metadata.part_number_alt_1_html || spart.part_number_alt_1
                                            }, null, 8, _hoisted_4),
                                            _createTextVNode(")")
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                subtitle: _withCtx(() => [
                                    _createElementVNode("span", {
                                        innerHTML: spart.metadata.description_html || spart.description
                                    }, null, 8, _hoisted_5),
                                    (spart.metadata.serial_number_html || spart.serial_number)
                                        ? (_openBlock(), _createElementBlock("b", _hoisted_6, [
                                            _hoisted_7,
                                            _createElementVNode("span", {
                                                class: "text-vibrantRed",
                                                innerHTML: spart.metadata.serial_number_html || spart.serial_number
                                            }, null, 8, _hoisted_8)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("span", _hoisted_9, " × " + _toDisplayString(spart.quantity), 1)
                                ]),
                                append: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        color: "blue-grey",
                                        icon: "mdi-minus-circle-outline",
                                        size: "compact",
                                        variant: "text",
                                        onClick: ($event) => (emit('toggleSparePart', spart))
                                    }, null, 8, ["onClick"])
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]),
                    _: 1
                }))
                : (_ctx.noPartsText)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "info",
                        variant: "flat",
                        color: "warmLightGray"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", {
                                innerHTML: _ctx.noPartsText || 'No parts found'
                            }, null, 8, _hoisted_10)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true);
        };
    }
});
